module.exports = __webpack_public_path__ + "img/25_41.2fa48714.png";